<template>
  <CommonLayout selectedNav="image">
    <div class="tx-wrap">
      <div class="tx-hero tx-hero-left">
        <h1 class="tx-hero-title">图片 <em>工具箱</em></h1>
        <p class="tx-hero-sub">压缩 · 改尺寸 · 裁剪 · 水印 · 多图转 PDF</p>
      </div>

      <div class="tx-grid-cards">
        <div class="tx-card" v-for="tool in tools" :key="tool.action">
          <span class="tx-corner tl"></span><span class="tx-corner tr"></span>
          <span class="tx-corner bl"></span><span class="tx-corner br"></span>

          <div class="tx-card-head">
            <i :class="tool.icon" class="tx-card-icon"></i>
            <div>
              <div class="tx-card-title">{{ tool.title }}</div>
              <div class="tx-card-desc">{{ tool.desc }}</div>
            </div>
          </div>

          <el-upload class="tx-tool-upload" :ref="'up_' + tool.action"
            :auto-upload="false" :show-file-list="true" :multiple="tool.multi"
            :limit="tool.multi ? maxUploadCount : 1" :accept="tool.accept"
            :on-change="(f, l) => onFileChange(tool.action, l)"
            :on-remove="(f, l) => onFileChange(tool.action, l)" :on-exceed="handleExceed"
            :file-list="state[tool.action].files" list-type="picture-card">
            <i class="el-icon-plus"></i>
          </el-upload>

          <div class="tx-params" v-if="tool.params.length">
            <div class="tx-param" v-for="p in tool.params" :key="p.key">
              <label class="tx-param-label">{{ p.label }}</label>
              <el-select v-if="p.type === 'select'" v-model="state[tool.action].params[p.key]"
                size="small" class="tx-param-input">
                <el-option v-for="o in p.options" :key="o.v" :label="o.t" :value="o.v"></el-option>
              </el-select>
              <el-input v-else v-model="state[tool.action].params[p.key]" size="small"
                class="tx-param-input" :placeholder="p.label"></el-input>
            </div>
          </div>

          <el-button type="primary" class="tx-run-btn" :loading="state[tool.action].loading"
            :disabled="state[tool.action].files.length === 0" @click="runTool(tool)">
            <i v-if="!state[tool.action].loading" class="el-icon-video-play"></i> 执行
          </el-button>

          <div class="tx-tool-result" v-if="state[tool.action].result || state[tool.action].error">
            <div class="tx-result-ok" v-if="state[tool.action].result">
              <i class="el-icon-circle-check"></i>
              <span class="tx-result-name">{{ state[tool.action].result.fileName }}</span>
              <el-link type="success" :underline="false" class="tx-dl" @click="download(tool, state[tool.action].result)">
                <i class="el-icon-download"></i> 下载
              </el-link>
              <el-link type="info" :underline="false" class="tx-del" @click="delResult(tool, state[tool.action].result)">
                <i class="el-icon-delete"></i>
              </el-link>
            </div>
            <div class="tx-result-err" v-if="state[tool.action].error">
              <i class="el-icon-warning"></i> {{ state[tool.action].error }}
              <el-tooltip v-if="state[tool.action].hint" :content="state[tool.action].hint" placement="top">
                <i class="el-icon-question tx-help"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonLayout>
</template>

<style scoped>
.tx-wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 36px 28px 60px;
  animation: txFadeUp .5s ease both;
}

@keyframes txFadeUp {
  from {
    opacity: 0;
    transform: translateY(14px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tx-hero-left {
  text-align: left;
  margin-bottom: 26px;
}

.tx-hero-title {
  margin: 0 0 8px;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 4px;
  color: #e2f5ff;
}

.tx-hero-title em {
  font-style: normal;
  background: linear-gradient(90deg, #22d3ee, #818cf8, #22d3ee);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: txShine 4s linear infinite;
}

@keyframes txShine {
  to {
    background-position: 200% center;
  }
}

.tx-hero-sub {
  margin: 0;
  color: #5b7295;
  font-size: 13px;
  letter-spacing: 2px;
}

.tx-grid-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 18px;
}

.tx-card {
  position: relative;
  padding: 18px;
  border-radius: 14px;
  background: rgba(13, 20, 36, .72);
  border: 1px solid rgba(56, 189, 248, .2);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 14px 36px rgba(0, 0, 0, .4);
  transition: transform .25s, border-color .25s, box-shadow .25s;
}

.tx-card:hover {
  transform: translateY(-3px);
  border-color: rgba(34, 211, 238, .45);
  box-shadow: 0 18px 44px rgba(34, 211, 238, .12);
}

.tx-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  border-color: #22d3ee;
  border-style: solid;
  border-width: 0;
  filter: drop-shadow(0 0 4px rgba(34, 211, 238, .7));
}

.tx-corner.tl {
  top: -1px;
  left: -1px;
  border-top-width: 2px;
  border-left-width: 2px;
}

.tx-corner.tr {
  top: -1px;
  right: -1px;
  border-top-width: 2px;
  border-right-width: 2px;
}

.tx-corner.bl {
  bottom: -1px;
  left: -1px;
  border-bottom-width: 2px;
  border-left-width: 2px;
}

.tx-corner.br {
  bottom: -1px;
  right: -1px;
  border-bottom-width: 2px;
  border-right-width: 2px;
}

.tx-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.tx-card-icon {
  font-size: 26px;
  color: #22d3ee;
  text-shadow: 0 0 14px rgba(34, 211, 238, .6);
}

.tx-card-title {
  color: #e2f5ff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
}

.tx-card-desc {
  color: #5b7295;
  font-size: 12px;
  margin-top: 2px;
}

.tx-tool-upload {
  margin-bottom: 12px;
}

.tx-tool-upload .el-upload-list--picture-card .el-upload-list__item {
  background: rgba(7, 12, 24, .6);
  border: 1px solid rgba(56, 189, 248, .3);
}

.tx-tool-upload .el-upload--picture-card {
  background: rgba(7, 12, 24, .5);
  border: 1px dashed rgba(34, 211, 238, .4);
  border-radius: 10px;
  color: #22d3ee;
}

.tx-tool-upload .el-upload--picture-card:hover {
  border-color: #22d3ee;
}

.tx-params {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.tx-param {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tx-param-label {
  color: #8fd8ee;
  font-size: 12px;
  width: 96px;
  flex-shrink: 0;
}

.tx-param-input {
  flex: 1;
}

.tx-param-input .el-input__inner {
  background: rgba(7, 12, 24, .6);
  border: 1px solid rgba(56, 189, 248, .3);
  color: #e2f5ff;
  border-radius: 8px;
}

.tx-run-btn {
  width: 100%;
  height: 42px;
  border: none !important;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #04121c !important;
  background: linear-gradient(90deg, #22d3ee, #818cf8) !important;
  box-shadow: 0 6px 18px rgba(34, 211, 238, .3);
}

.tx-run-btn:disabled {
  opacity: .45;
}

.tx-tool-result {
  margin-top: 12px;
  border-top: 1px dashed rgba(56, 189, 248, .18);
  padding-top: 10px;
}

.tx-result-ok {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #34d399;
  font-size: 13px;
}

.tx-result-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #c7d7ee;
}

.tx-dl {
  color: #34d399 !important;
  font-weight: 600;
}

.tx-del {
  color: #f87171 !important;
}

.tx-result-err {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fca5a5;
  font-size: 12.5px;
}

.tx-help {
  color: #5b7295;
  cursor: help;
}

@media (max-width: 768px) {
  .tx-wrap {
    padding: 22px 14px 48px;
  }

  .tx-grid-cards {
    grid-template-columns: 1fr;
  }
}
</style>

<script>
import CommonLayout from './common/commonPage.vue';
import { imageTool } from '../api/tools';
import { downloadAndSave, deleteFile } from '../api/conversion';
import { normalizeError } from '../api/request';
import {
  MAX_UPLOAD_COUNT,
  checkFileSize,
  checkFileList,
} from '../utils/upload-limit';

const IMG_TOOLS = [
  { action: 'compress', title: '压缩到指定体积', icon: 'el-icon-picture', desc: '按目标体积自动压缩', multi: false, accept: 'image/*', params: [{ key: 'targetSizeKB', label: '目标体积(KB)', type: 'text', def: '200' }, { key: 'quality', label: '质量0-100', type: 'text', def: '80' }] },
  { action: 'resize', title: '改尺寸', icon: 'el-icon-scale-to-original', desc: '按宽高缩放', multi: false, accept: 'image/*', params: [{ key: 'width', label: '宽(px)', type: 'text', def: '' }, { key: 'height', label: '高(px,空=等比)', type: 'text', def: '' }] },
  { action: 'crop', title: '裁剪', icon: 'el-icon-crop', desc: '按坐标裁剪', multi: false, accept: 'image/*', params: [{ key: 'x', label: 'X', type: 'text', def: '0' }, { key: 'y', label: 'Y', type: 'text', def: '0' }, { key: 'w', label: '宽', type: 'text', def: '100' }, { key: 'h', label: '高', type: 'text', def: '100' }] },
  { action: 'watermark', title: '水印', icon: 'el-icon-edit', desc: '添加文字水印', multi: false, accept: 'image/*', params: [{ key: 'text', label: '水印文字', type: 'text', def: '纯净未知' }, { key: 'opacity', label: '透明度0-1', type: 'text', def: '0.3' }, { key: 'position', label: '位置', type: 'select', options: [{ v: 'center', t: '居中' }, { v: 'tile', t: '平铺' }, { v: 'bottom-right', t: '右下' }], def: 'center' }] },
  { action: 'to_pdf', title: '多图转 PDF', icon: 'el-icon-document', desc: '将多张图片合成 PDF', multi: true, accept: 'image/*', params: [] },
];

export default {
  props: { selectedNav: { type: String, default: 'image' } },
  components: { CommonLayout },
  data() {
    const state = {};
    IMG_TOOLS.forEach((t) => {
      const params = {};
      t.params.forEach((p) => { params[p.key] = p.def; });
      state[t.action] = { files: [], params, loading: false, result: null, error: null, hint: null };
    });
    return { tools: IMG_TOOLS, state, maxUploadCount: MAX_UPLOAD_COUNT };
  },
  methods: {
    _extOf(name) {
      const m = String(name || '').match(/\.([A-Za-z0-9]+)$/);
      return m ? m[1].toLowerCase() : '';
    },

    // ⚠️ 本组件是 auto-upload=false，before-upload 不会触发，只能在 on-change 里校验。
    // 超限文件直接剔除并明确报错，避免用户白等整个文件传完才被后端拒。
    onFileChange(action, fileList) {
      const kept = [];
      for (const f of fileList || []) {
        if (f.status === 'fail') continue;
        const sizeErr = checkFileSize(f);
        if (sizeErr) {
          this.$message.error(sizeErr);
          continue;
        }
        kept.push(f);
      }
      if (kept.length > MAX_UPLOAD_COUNT) {
        this.$message.warning(`最多只能上传 ${MAX_UPLOAD_COUNT} 个文件，多出的已忽略`);
        kept.length = MAX_UPLOAD_COUNT;
      }
      this.state[action].files = kept;
    },
    handleExceed() {
      this.$message.warning(`最多只能上传 ${MAX_UPLOAD_COUNT} 个文件，请先移除部分文件再添加`);
    },
    runTool(tool) {
      const s = this.state[tool.action];
      if (s.files.length === 0) {
        // 原来是静默 return，用户点了没反应；改为明确提示
        this.$message.warning('请先选择要处理的图片');
        return;
      }
      // 提交前兜底校验（与选中时同一套规则）
      const limitErr = checkFileList(s.files);
      if (limitErr) {
        this.$message.error(limitErr);
        return;
      }
      const form = new FormData();
      s.files.forEach((f) => { if (f.raw) form.append('file', f.raw); });
      Object.keys(s.params).forEach((k) => {
        const v = s.params[k];
        if (v !== '' && v !== null && v !== undefined) form.append(k, String(v));
      });
      s.loading = true;
      s.result = null;
      s.error = null;
      s.hint = null;
      imageTool(tool.action, form)
        .then((resp) => { s.result = resp.data; })
        .catch((e) => {
          const info = normalizeError(e);
          s.error = info.message;
          s.hint = info.hint;
        })
        .finally(() => { s.loading = false; });
    },
    download(tool, result) {
      const src = (this.state[tool.action].files[0] && this.state[tool.action].files[0].name) || 'image';
      const base = src.replace(/\.[^.]+$/, '');
      // 扩展名取自**后端产物的真实文件名**：压缩/改尺寸/裁剪/水印 跟随源图格式
      // （png/jpg/webp…），多图转 PDF 为 pdf。写死扩展名会导致 Windows 无法识别。
      const ext = this._extOf(result.fileName || result.filePath) || 'png';
      const name = `${base}_${tool.action}.${ext}`;
      this.$message.info('开始下载，大文件可能需要一些时间…');
      downloadAndSave(result.filePath, name)
        .then(() => this.$message.success('下载完成'))
        .catch(() => this.$message.error('下载失败，请确认后端在线'));
    },
    delResult(tool, result) {
      if (!result.filePath) return;
      deleteFile(result.filePath)
        .then(() => { this.state[tool.action].result = null; this.$message.success('已删除产物文件'); })
        .catch((e) => { const info = normalizeError(e); this.$message.warning('删除失败：' + info.message); });
    },
  },
};
</script>
